import React from 'react';
import { motion } from 'framer-motion';

const CelebrationOverlay = ({ showCelebration, userName }) => {
  if (!showCelebration) return null;

  return (
    <motion.div
      className="celebration-overlay"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.5 }}
    >
      <div className="confetti-container">
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
        <div className="confetti"></div>
      </div>
      <div className="celebration-card">
        <div className="celebration-emoji">🎉</div>
        <div className="celebration-welcome">Welcome</div>
        <div className="celebration-name">{userName}</div>
        <div className="celebration-message">
          Your chat is now personalized and I will remember your name
        </div>
        <div className="celebration-sparkles">✨ ✨ ✨</div>
      </div>
    </motion.div>
  );
};

export default CelebrationOverlay; 